import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, BackHandler, Platform, StatusBar, FlatList, ActivityIndicator } from 'react-native';
import Btn from "../components/btn"

import Colors from '../constants/Colors';

import { NativeBaseProvider, useMediaQuery } from 'native-base';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteMDFList, getAllListmdf } from '../store/action/userProduct';
import AwesomeAlert from 'react-native-awesome-alerts';
import { useIsFocused } from '@react-navigation/native';
import { getProfileinfo, logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';









const List = (props) => {

    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const TypeIdGroup = useSelector((store) => store.finalproduct.datagroup);
    const dispatch = useDispatch();
    const [task, setTask] = useState("");
    const [MDFList, setMDFList] = useState([]);
    const [Wallet, setWallet] = useState(false)
    const [loading, setloading] = useState(false)
    const [State, setState] = useState({

        showModal2: false,
        isLoading: false

    })



    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };


    
    const getMDFLISTHandler = async () => {
        try {
            setloading(true)
            setState({ ...State, isLoading: true })

            const res = await dispatch(getAllListmdf(tokens, props.route.params.ids));
            setMDFList(res.data.data.slices.data)
            //console.log(res.data.data.slices.data);


            setState({ ...State, isLoading: false })
            setloading(false)

        } catch (err) {
            // logOutHandler();
        }
    };


    const isfocuce = useIsFocused();
    useEffect(() => {
        getMDFLISTHandler()
        getprofileHandler()
    }, [isfocuce])




    const DELETEMDFHandler = async (id) => {
        try {
            //console.log(id);
            setState({ ...State, isLoading: true })
            const res = await DeleteMDFList(tokens, id);

            if (res.status == "success") {
                setWallet(true)


            }
            // console.log(res);
            setState({ ...State, isLoading: false })
        } catch (err) {
            console.log(err);
        }
    };








    const total = (MDFList ? (MDFList.reduce((a, v) => a = a + JSON.parse(v.count), 0)) : 0);



    const getprofileHandler = async () => {
        try {

            const res = await dispatch(getProfileinfo(tokens));
            //console.log(res.data.data.user);
            setTask(res.data.data.user)


        } catch (err) {
            // logOutHandler();
        }
    }



    function handleBackButtonClick() {
        if (props.route.params.ids) {
            props.navigation.goBack();
        } else {
            props.navigation.navigate("order");
        }


        return true;
    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);





    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });




    return !loading
        ?
        (


            <NativeBaseProvider>


                <View style={{
                    width: isSmallScreen ? "100%" : 500,
                    height: "100%",
                    marginLeft:isSmallScreen?0:"35%",
                    backgroundColor: Colors.background,
                    position: Platform.OS == "web" ? "fixed" : "relative"
                }}>


                    <View style={styles.viewHeader}>
                        <StatusBar backgroundColor={Colors.primary} />
                        {/* <TouchableOpacity style={styles.menu}   >
                        <Ionicons onPress={() => props.navigation.navigate("ordercolor")} name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity> */}

                        <View style={styles.textheader}>
                            <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                                لیست تکه ها
                            </Text>
                        </View>

                    </View>





                    <View style={{ width: "100%", height: Platform.OS == "web" ? "85%" : "78%", }} >
                        <FlatList
                            onRefresh={getMDFLISTHandler}
                            refreshing={State.isLoading}
                            data={MDFList}

                            showsVerticalScrollIndicator={false}
                            renderItem={({ item, index }) =>

                                <View key={index} style={{
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: "90%",
                                    height: task.status == "false" ? 320 : 250,
                                    backgroundColor: Colors.background1,
                                    marginTop: 20,
                                    left: "5%",
                                    borderRadius: 10,
                                    borderWidth: 2,
                                    borderColor: Colors.secondText,

                                }}>

                                    {task.status == "false" ?
                                        <View style={{ width: "100%", height: 60, }}>

                                            <View style={styles.viewtitile}>
                                                <View style={{ borderRadius: 5, width: "80%", height: 60, justifyContent: "center", }}>
                                                    <Text style={styles.texttitle}>{item.product == null ? "تکه سفید" : item.product.title}</Text>

                                                </View>

                                            </View>


                                        </View>
                                        :
                                        <View></View>}

                                    {task.status == "false" ?
                                        <View style={{ width: "90%", height: 1, backgroundColor: Colors.secondText2 }}></View>
                                        :
                                        <View></View>}

                                    <View style={styles.viewline} >
                                        <Text style={{ textDecorationLine: 'underline', position: "absolute", left: 20, fontFamily: "MontserratBold", fontSize: 20, color: Colors.primarydark, }}> {index + 1} </Text>
                                        <Text style={styles.textlineL}>تعداد تکه : <Text style={styles.textline}>{item.count}</Text></Text>
                                        <Text style={styles.textlineR}>کد محصول : <Text style={styles.textline}>{item.id}</Text></Text>

                                    </View>

                                    <View style={{ width: "100%", height: 140, flexDirection: 'row', padding: 10 }}>

                                        <View style={{ width: "15%", height: 140, flexDirection: "column", alignItems: "flex-end" }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", top: 25 }}>  {item.width_one == "1" ? "ن" : ""}</Text>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", top: 60 }}>  {item.width_one == "2" ? "ف" : ""}</Text>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", bottom: 25 }}>  {item.width_one == "3" ? "ش" : ""}</Text>
                                        </View>


                                        <View style={{ width: "70%", height: 140, flexDirection: "column" }}>
                                            <View style={{ width: "100%", height: "20%", flexDirection: 'row' }}>
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", right: "10%" }}>{item.length_one == "1" ? "ن" : ""}</Text>
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", left: "45%" }}>{item.length_one == "2" ? "ف" : ""} ({item.height})</Text>
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", left: "10%" }}>{item.length_one == "3" ? "ش" : ""}</Text>
                                            </View>

                                            <View style={{ width: "100%", height: "60%", backgroundColor: Colors.secondText3 }}>
                                            </View>

                                            <View style={{ width: "100%", height: "20%", flexDirection: 'row' }}>
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", right: "10%" }}>{item.width_two == "1" ? "ن" : ""}</Text>
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", left: "50%" }}>{item.width_two == "2" ? "ف" : ""}</Text>
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", left: "10%" }}>{item.width_two == "3" ? "ش" : ""}</Text>
                                            </View>
                                        </View>




                                        <View style={{ width: "15%", height: 140, flexDirection: "column", }}>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", top: 25 }}>{item.length_two == "1" ? "ن" : ""}  </Text>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", top: 60 }}>{item.length_two == "2" ? "ف" : ""} ({item.width})  </Text>
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3, position: "absolute", bottom: 25 }}>{item.length_two == "3" ? "ش" : ""}  </Text>
                                        </View>

                                    </View>


                                    <View style={styles.viewbtn} >
                                        <Btn
                                            label="حذف"
                                            nameicon="delete-outline"
                                            sizeicon={18}
                                            styleicon={{ position: "absolute", left: Platform.OS === "web" ? 20 : 10, top: Platform.OS === "web" ? 0 : 5, }}
                                            touchableStyle={{ backgroundColor: Colors.background1, elevation: 0 }}
                                            style={{ width: "48%", marginLeft: "5%", marginTop: 10, }}
                                            textStyle={{ color: Colors.black, right: 10 }}
                                            onPress={() => DELETEMDFHandler(item.id)}

                                        />
                                        <Btn
                                            label="ویرایش"
                                            nameicon="pencil-outline"
                                            sizeicon={18}
                                            styleicon={{ position: "absolute", left: Platform.OS === "web" ? 30 : 20, top: Platform.OS === "web" ? 0 : 5, }}
                                            coloricon={Colors.background}
                                            touchableStyle={{ backgroundColor: Colors.yellowlight }}
                                            style={{ width: "48%", marginRight: "3%", marginTop: 10, }}
                                            textStyle={{ right: 10 }}
                                            onPress={() => props.navigation.navigate("form", {
                                                back: "1",
                                                Sliceid: item.id,
                                                height_strip: item.height_strip == "single" ? "single" : "double",
                                                color_strip: item.color_strip == "color" ? "color" : "other",
                                                width_strip: item.width_strip == "1" ? "1" : "2",










                                            })}
                                        />
                                    </View>

                                </View>




                            }
                            keyExtractor={item => item.id}

                        />




                    </View>

                    <View style={{
                        position: Platform.OS == "web" ? "fixed" : "absolute",
                        bottom: Platform.OS == "web" ? 0 : 0.1,
                        flexDirection: "row",
                        width:isSmallScreen ?"100%":500 ,
                        height: 60,
                        backgroundColor: Colors.background,




                    }}>

                        {MDFList.length == [] ?
                            <View></View>
                            :

                            <Btn
                                label="تکمیل سفارش"
                                coloricon={Colors.background1}
                                style={{ width: "48%", marginLeft: "5%", marginTop: Platform.OS == "web" ? 10 : 5, }}
                                textStyle={{ bottom: 10, }}
                                onPress={() => {

                                    if (!props.route.params.ids) {
                                        props.navigation.navigate("service", {
                                            totalmdf: total,
                                            number: "",
                                            ostany: task.state_id,
                                            citys: task.city_id
                                        })
                                    } else {
                                        props.navigation.navigate("final", {
                                            orderid: props.route.params.ids,
                                            gruop_id: TypeIdGroup,
                                            totalmdf: total
                                        })
                                    }


                                }}

                            />
                        }

                        <Btn
                            label="افزودن قطعه جدید"
                            nameicon="plus"
                            sizeicon={18}
                            styleicon={{ position: "absolute", left: Platform.OS === "web" ? 60 : 50, top: Platform.OS === "web" ? -1 : 4, }}
                            coloricon={Colors.black}
                            touchableStyle={{ backgroundColor: Colors.background2, elevation: 0 }}
                            style={{ width: MDFList.length == [] ? "110%" : "48%", marginRight: "3%", marginTop: Platform.OS == "web" ? 10 : 5, }}
                            textStyle={{ right: 10, color: Colors.black }}
                            onPress={() => props.navigation.navigate("form", {
                                orderid: props.route.params.ids ? props.route.params.ids : "",
                                idgroup: TypeIdGroup,
                                back: "1",

                            })}
                        />
















                    </View>
















                    <AwesomeAlert
                        show={Wallet}
                        showProgress={false}
                        title="موفق"
                        message="تکه با موفقیت حذف شد"
                        closeOnTouchOutside={false}
                        closeOnHardwareBackPress={false}
                        // showCancelButton={true}
                        showConfirmButton={true}
                        // cancelText="باشه"
                        confirmText="باشه"
                        confirmButtonColor={Colors.success}
                        // onCancelPressed={() => {
                        //   setShow(false);
                        // }}
                        onConfirmPressed={() => {
                            setWallet(false);
                            getMDFLISTHandler()

                            //props.navigation.navigate("home")
                        }}
                        titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: Colors.success }}
                        messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                        confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    />
                </View>
            </NativeBaseProvider>
        ) : (
            <NativeBaseProvider>
                <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: Colors.background }} >
                    <ActivityIndicator
                        animating={loading} size={30} color={Colors.primary} />

                    <Text style={{ fontFamily: "MontserratBold", fontSize: 25, color: Colors.primary, marginTop: 30 }}>لطفا شکیبا باشید...</Text>
                </View>
            </NativeBaseProvider>
        )

}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: "35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 100,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "5%",
        top: Platform.OS == "web" ? "15%" : "35%"
    },
    viewfooter: {
        position: Platform.OS == "web" ? "fixed" : "absolute",
        bottom: Platform.OS == "web" ? 0 : 0.1,
        flexDirection: "row",
        width: "100%",
        height: 60,
        backgroundColor: Colors.background,




    },



    view: {
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        height: 320,
        backgroundColor: Colors.background1,
        marginTop: 20,
        left: "5%",
        borderRadius: 10,
        borderWidth: 2,
        borderColor: Colors.secondText


    },


    viewtitile: {
        borderRadius: 5,
        flexDirection: "row",
        width: "91%",
        height: 70,
        backgroundColor: Colors.background1,
        left: Platform.OS === "web" ? "4%" : "27%",
        borderRadius: 10,
    },
    texttitle: {
        fontFamily: "Montserrat",
        fontSize: 15,
        color: Colors.black,



    }
    ,
    viewline: {
        width: "100%",
        height: 30,
        justifyContent: "center",
        flexDirection: "row",
        marginTop: 10

    },
    textlineL: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.black,
        position: "absolute",
        right: "50%"

    },
    textlineR: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.black,
        position: "absolute",
        right: "5%"

    },
    textline: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.secondText3,

    }, viewbtn: {
        width: "100%",
        height: 50,
        justifyContent: "center",
        flexDirection: "row",
        marginTop: 5
    }
})




export default List